import { Collapseable } from "components/UI/Collapseable/Collapseable";
import { useGeneralForm } from "components/UI/GeneralForm/hooks/useGeneralForm";
import { usePaldockTranslation } from "hooks/usePaldockTranslation";
import { FC } from "react";
import { useFieldArray } from "react-hook-form";

import { HowToUseSectionForm } from "./HowToUseSectionForm";
import { FormData } from "../formSchema";

interface HowToUseSectionProps {
    name: number; // index of the response handler in the responseHandlers array
    methodIndex: number; // index of the method in the methods array
}

export const HowToUseSection: FC<HowToUseSectionProps> = ({ name, methodIndex }) => {
    const { t } = usePaldockTranslation("ui.connection-creator-editor.response-how-to-use");
    const generalFormUtils = useGeneralForm<FormData>();
    const { control } = generalFormUtils;

    // Path to responseConnectionProperties for this response handler
    const howToUsePath =
        `methods.${methodIndex}.requestConfig.responseHandlers.${name}.responseConnectionProperties` as const;

    const { fields, append, remove } = useFieldArray({
        control,
        name: howToUsePath,
    });

    return (
        <Collapseable
            title={t("sections.how_to_use.title")}
            withAddItem
            handleAddItem={() => append({})}
            addItemTitle={t("sections.how_to_use.add_item")}
            className="bg-neutral-200"
        >
            {fields.map((field, index) => (
                <HowToUseSectionForm
                    key={field.id}
                    methodIndex={methodIndex}
                    responseHandlerIndex={name}
                    name={index}
                    handleRemove={() => remove(index)}
                    control={control}
                />
            ))}
        </Collapseable>
    );
};
